<template>
    <div :class="classObj" role="status" :style="{'width': width, 'height': height}">
        <span class="sr-only">Loading....</span>
    </div>
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        type: {
            type: String,
            default: 'border',
            validator(v) {
                return [
                    "border",
                    "grow"
                ].includes(v)
            }
        },
        colour: {
            type: String,
            default: 'dark',
            validator(v) {
                return [
                    "primary",
                    "secondary",
                    "success",
                    "danger",
                    "warning",
                    "info",
                    "light",
                    "dark"
                ].includes(v)
            }
        },
        height: {
            type: String,
            default: '1.5rem'
        },
        width: {
            type: String,
            default: '1.5rem'
        }
    },
    computed: {
        classObj() {
            let { type, colour } = this;
            let klass = {};

            klass["spinner-" + type] = true;
            klass["text-" + colour] = true;

            return klass;
        },
    }
}
</script>